<template>
  <v-text-field
    v-model="valorFormateado"
    :label="label"
    :disabled="disabled"
    :rules="rules"
    prepend-icon="mdi-currency-usd"
    @keydown.enter="onEnter"
    @focus="isFocused = true"
    @blur="onBlur"
    @keydown.native.stop="onKeydown"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: 'Monto',
    },
    prefix: {
      type: String,
      default: '$',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalValue: this.value,
      isFocused: false,
    };
  },
  computed: {
    valorFormateado: {
      get() {
        if (this.isFocused) {
          return this.internalValue.toString().replace('.', ',');
        }
        return new Intl.NumberFormat('es-ES', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(this.internalValue);
      },
      set(newValue) {
        // Lógica de limpieza simplificada y robusta
        const cleanedValue = this.limpiarValor(newValue);
        this.internalValue = isNaN(parseFloat(cleanedValue)) ? 0 : parseFloat(cleanedValue);
        this.$emit('input', this.internalValue);
      },
    },
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  methods: {
    onKeydown(event) {
      if (event.key === '.' && event.code === 'NumpadDecimal') {
        event.preventDefault();
        const tieneComa = this.valorFormateado.includes(',');
        if (!tieneComa) {
          event.target.value += ',';
        }
      }
    },
    onBlur() {
      this.isFocused = false;
    },
    // Método para limpiar y convertir el valor de entrada
    limpiarValor(value) {
      let cleaned = '';
      let hasDecimal = false;
      const valueString = value.toString();

      for (let i = 0; i < valueString.length; i++) {
        const char = valueString[i];
        if (char >= '0' && char <= '9') {
          cleaned += char;
        } else if ((char === ',' || char === '.') && !hasDecimal) {
          cleaned += '.'; // Siempre usamos el punto internamente
          hasDecimal = true;
        }
      }
      return cleaned;
    },
    onEnter(event) {
      this.$emit('enter', event)
    }
  },
};
</script>